/**
 * 👥 UsuarioService.js
 * Servicio para gestionar usuarios (solo lectura para admin)
 */
import api from "../api/api";

const API_URL = "/usuarios";

// === OPERACIONES DE LECTURA ===

/** Obtiene todos los usuarios */
export const getAllUsuarios = () => api.get(API_URL);

/** Obtiene un usuario por ID */
export const getUsuarioById = (id) => api.get(`${API_URL}/${id}`);

/** Obtiene perfil de un usuario */
export const getPerfilUsuario = (id) => api.get(`${API_URL}/perfil/${id}`);

// === OPERACIONES ADMINISTRATIVAS ===

/**
 * Desactiva un usuario (ACTIVO -> INACTIVO).
 * Solo ADMIN. Devuelve 409 si la cuenta no está ACTIVA.
 */
export const desactivarUsuario = (id) => api.patch(`${API_URL}/${id}/desactivar`);

/**
 * Reactiva un usuario dado de baja (INACTIVO -> ACTIVO).
 * Solo ADMIN. Devuelve 409 si la cuenta no está INACTIVA.
 *
 * No emite un QR nuevo ni requiere reescanear: el socio conserva su membresía,
 * su número de socio y el mismo QR, que vuelve a validar al instante.
 */
export const reactivarUsuario = (id) => api.patch(`${API_URL}/${id}/reactivar`);
